/* global SeasonPagesEnabled */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import Regex from 'helpers/Regex';
import Dropdown from 'components/Dropdown';
import DropdownIcon from 'components/DropdownIcon';
import Scrollspy from 'react-scrollspy';
import { Sticky } from 'react-sticky';
import { Link, browserHistory } from 'react-router';
import classNames from 'classnames';
import _ from 'lodash';
import { getUrlTarget, PAGE_TYPE_ARTICLE, isArticleTab } from 'helpers/ContentHelper';
import { helperGetShowUrl, helperGetPersonalityUrl } from 'helpers/RouteHelper';
import {
  Events,
  getTealiumDetailTabData,
  PageNames,
  handleAnalytics,
} from '@foxcorp/delta-web-analytics';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import {
  getTabName,
  getTabSlug,
  getTabUrl,
  scrollToElement,
  isPlaylist,
  hasChildren,
  PANEL_TYPE_CLIPS,
  isSeasonPanel,
  checkForDOMNode,
  clearFetchNodeInterval,
} from '../../SeriesDetailHelpers';
import { getPersonalityTabSlug, getPersonalityTabUrl } from '../../PersonalityDetailHelpers';
import TabListMobile from '../TabListMobile';
import seasonDropdownTheme from './SeasonDropdown.module.scss';
import Style from './TabList.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    disableHardwareAcceleration: true,
    tabListSidebar: true,
    scrollOffsetTop: 450,
    scrollOffsetTopArticle: 300,
  },
  [SITE_PLATFORM_WEB]: {
    disableHardwareAcceleration: true,
    tabListSidebar: true,
    scrollOffsetTop: 450,
    scrollOffsetTopArticle: 300,
  },
  [SITE_PLATFORM_TABLET]: {
    disableHardwareAcceleration: false,
    tabListSidebar: false,
    scrollOffsetTop: 450,
    scrollOffsetTopArticle: 300,
  },
  [SITE_PLATFORM_MOBILE]: {
    disableHardwareAcceleration: false,
    tabListSidebar: false,
    scrollOffsetTop: 250,
    scrollOffsetTopArticle: 250,
  },
};

class TabList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      didTriggerLeapfrogEvent: false,
      videoContentDropdownOpen: false,
      selected: null,
      selectedSubMenu: null,
    };
    this.checkForDOMNode = checkForDOMNode.bind(this);
    this.clearFetchNodeInterval = clearFetchNodeInterval.bind(this);
  }

  componentDidMount() {
    const {
      pageType,
      breakpoint,
      isPersonality,
      tabs,
      tabIndex,
      subTabIndex,
      seriesData,
      utagSeriesType,
    } = this.props;
    const { didTriggerLeapfrogEvent } = this.state;
    const { scrollOffsetTop } = BREAKPOINTS[breakpoint];
    let selected = null;
    let selectedSubMenu = null;
    if (subTabIndex !== false && subTabIndex !== null) {
      selectedSubMenu = _.get(tabs, `${tabIndex}.id`, null);
      selected = _.get(tabs, `${tabIndex}.children.${subTabIndex}.id`, null);
    } else if (tabIndex !== false && tabIndex !== null) {
      selected = _.get(tabs, `${tabIndex}.id`, null);
    }
    const currentTab = _.find(tabs, { id: selected });
    const { pageTitle, selectedMenuItem } = getTealiumDetailTabData({
      seriesData,
      tab: currentTab,
    });
    if (!didTriggerLeapfrogEvent && !isPersonality) {
      handleAnalytics({
        event: Events.DETAIL_PAGE_MENU_ITEM_VIEW,
        payload: {
          pageName: `detail:${pageType}:${utagSeriesType}:${pageTitle}`,
          pageType: `detail:${utagSeriesType}:menu`,
          selectedMenuItem,
        },
      });
      this.setState({ didTriggerLeapfrogEvent: true });
    }
    this.setState({ selected, selectedSubMenu });
    if (_.includes(pageType, 'season-') || isPersonality) {
      scrollToElement({
        slug: pageType,
        nodeFetcher: this.checkForDOMNode,
        duration: 10000,
        clearNodeFetcher: this.clearFetchNodeInterval,
        offsetTop: scrollOffsetTop,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { isBrandingClicked, setIsBrandingClicked, tabs } = this.props;
    const { isBrandingClicked: prevIsBrandingClicked } = prevProps;
    const tabId = _.get(tabs, '0.id');
    if (!tabId) return;

    if (prevIsBrandingClicked !== isBrandingClicked) {
      this.setState({ selected: tabId });
    } else if (isBrandingClicked) {
      setIsBrandingClicked(false);
    }
  }

  createTabs({ tabs, isSubmenu = false }) {
    const {
      showId,
      noTabHomepage,
      seriesType,
      pageViewEvent,
      seriesData,
      utagSeriesType,
      togglePlaylist,
      playlist,
      tabIndex,
      isPersonality,
    } = this.props;
    const { selected, selectedSubMenu } = this.state;

    const listLinks = [];
    const slugs = [];
    const tabList = [];
    const playlistLinks = [];
    const videoContentList = [];

    tabs.forEach((tab, idx) => {
      if (!tab) return null;
      const { id: tabId, children, fullEpisodeCount } = tab;
      const tabType = _.get(tab, '@type', null);
      const isActiveTab = !this.isArticleWithoutTab() && selected === tabId;
      const hasEpisodes = fullEpisodeCount > 0;
      const tabClassActive = isActiveTab && Style.active;
      const tabClasses = classNames(Style.tab, tabClassActive);
      const name = getTabName({ tab, seriesType });
      const url = isPersonality
        ? getPersonalityTabUrl({ showId, tab, tabs, noTabHomepage, seriesType, isSubmenu })
        : getTabUrl({ showId, tab, tabs, noTabHomepage, seriesType, isSubmenu });
      const slug = isPersonality
        ? getPersonalityTabSlug({ tab, tabs, seriesType })
        : getTabSlug({ tab, tabs, seriesType });
      const { target, rel } = getUrlTarget(url);

      const onClick = () => {
        this.tabClick({ slug, tab });
      };
      const elementId = slug || tabId;
      if (elementId) {
        slugs.push(elementId);
      }

      const onClickAnalytics = () => {
        const { didTriggerLeapfrogEvent } = this.state;
        const { pageTitle, selectedMenuItem } = getTealiumDetailTabData({
          seriesData,
          tab,
        });
        pageViewEvent({
          pageName: PageNames.DETAIL,
          seriesType: utagSeriesType,
          pageTitle,
          selectedMenuItem,
        });
        if (!didTriggerLeapfrogEvent && !isPersonality) {
          handleAnalytics({
            event: Events.DETAIL_PAGE_MENU_ITEM_VIEW,
            payload: {
              pageName: `detail:${utagSeriesType}:${pageTitle}`,
              pageType: `detail:${utagSeriesType}:menu`,
              selectedMenuItem,
            },
          });
          this.setState({ didTriggerLeapfrogEvent: true });
        }
      };
      // Check if tab should be skipped here:
      const clipCount = _.get(tab, 'items.totalItems', null);
      if (tabType === PANEL_TYPE_CLIPS && clipCount === 0) return null;

      if (hasChildren(tab)) {
        _.forEach(_.get(tab, 'children'), childTab => {
          const childSlug = isPersonality
            ? getPersonalityTabSlug({ tab: childTab, tabs, seriesType })
            : getTabSlug({ tab: childTab, tabs, seriesType });
          const childUrl = isPersonality
            ? getPersonalityTabUrl({ showId, tab: childTab, tabs, noTabHomepage, seriesType })
            : getTabUrl({ showId, tab: childTab, tabs, noTabHomepage, seriesType });
          const childOnClick = () => {
            this.tabClick({ slug: childSlug, tab: childTab });
          };
          const childName = _.get(childTab, 'headline');
          tabList.push({
            id: _.get(childTab, 'id'),
            parentName: name,
            name: childName,
            tab: childTab,
            tabClasses,
            linkTo: childUrl,
            onClick: childOnClick,
          });
        });
      } else if (!isSeasonPanel(tab) || hasEpisodes) {
        tabList.push({
          id: tabId,
          name,
          tab,
          tabClasses,
          linkTo: url,
          onClick,
        });
      }

      if (SeasonPagesEnabled && isSeasonPanel(tab) && hasEpisodes) {
        const isSelected = tabIndex === idx;
        videoContentList.push({
          linkTo: url,
          name,
          onClick: () => {
            onClick();
            onClickAnalytics();
          },
          isSelected,
        });
      } else if (isPlaylist(tab)) {
        if (playlistLinks.length === 0) {
          const arrow = (
            <Icon color="white" icon={playlist ? 'keyboard-arrow-up' : 'keyboard-arrow-down'} />
          );
          // @todo: get the Clips text from the Language Object.
          listLinks.push(
            <li key={`list-${tabId}`}>
              <Link
                key={tabId}
                className={classNames(tabClasses, Style.clips)}
                target={target}
                rel={rel}
                onClick={() => {
                  if (togglePlaylist) togglePlaylist();
                }}
              >
                <span>Clips</span>
                <span className={Style.caret}>{arrow}</span>
              </Link>
              {this.renderPlaylistLinks(playlistLinks)}
            </li>,
          );
        }
        playlistLinks.push(
          <li key={`playlist-${tabId}`}>
            <Link
              className={classNames(tabClasses, Style.playlistItem)}
              to={url}
              target={target}
              rel={rel}
              onClick={() => {
                if (onClick) onClick();
                onClickAnalytics();
              }}
            >
              {name}
            </Link>
          </li>,
        );
      } else if (hasChildren(tab)) {
        const { listLinks: childListLinks, slugs: childSlugs } = this.createTabs({
          tabs: children,
          isSubmenu: true,
        });
        _.forEach(childSlugs, childSlug => slugs.push(childSlug));
        const subMenuOpen = selectedSubMenu === tabId;
        const subMenuOpenClass = subMenuOpen ? Style.open : null;
        const subMenuClasses = classNames(Style.subMenu, subMenuOpenClass);
        const subMenuIcon = (
          <Icon
            theme={Style}
            color="white"
            viewBox="5 5 14 14"
            icon={subMenuOpen ? 'keyboard-arrow-up' : 'keyboard-arrow-down'}
          />
        );
        listLinks.push(
          <div>
            <Link
              key={`link-${tabId}`}
              className={tabClasses}
              target={target}
              rel={rel}
              onClick={() => {
                onClick();
                onClickAnalytics();
              }}
            >
              {name} {subMenuIcon}
            </Link>
            <div className={subMenuClasses}>{childListLinks}</div>
          </div>,
        );
      } else if ((onClick && !isSeasonPanel(tab)) || !SeasonPagesEnabled) {
        listLinks.push(
          <Link
            key={`link-${tabId}`}
            className={tabClasses}
            to={url}
            target={target}
            rel={rel}
            onClick={() => {
              onClick();
              onClickAnalytics();
            }}
          >
            {name}
          </Link>,
        );
      } else if (!isSeasonPanel(tab)) {
        listLinks.push(
          <li key={`list-${tabId}`}>
            <Link
              key={tabId}
              className={tabClasses}
              to={url}
              target={target}
              rel={rel}
              onClick={onClickAnalytics}
            >
              {name}
            </Link>
          </li>,
        );
      }
      return null;
    });
    return {
      listLinks,
      playlistLinks,
      videoContentList,
      slugs,
      tabList,
    };
  }

  isArticleWithoutTab() {
    const { pageType, tabIndex } = this.props;
    const isArticleWithoutTab = tabIndex === false && pageType === PAGE_TYPE_ARTICLE;
    return isArticleWithoutTab;
  }

  tabClick({ slug, tab, ignoreScroll }) {
    const { breakpoint } = this.props;
    const { tabListSidebar, scrollOffsetTop, scrollOffsetTopArticle } = BREAKPOINTS[breakpoint];
    const { id: tabId } = tab;
    if (tabListSidebar && hasChildren(tab)) {
      this.toggleSubMenu(tabId);
    } else {
      this.setState({ selected: tabId });
    }
    const scrollElement = slug || tabId;
    const offsetTop = isArticleTab(tab) ? scrollOffsetTopArticle : scrollOffsetTop;

    if (scrollElement && !ignoreScroll) {
      scrollToElement({
        slug: scrollElement,
        nodeFetcher: this.checkForDOMNode,
        duration: 10000,
        clearNodeFetcher: this.clearFetchNodeInterval,
        offsetTop,
      });
    }
  }

  toggleSubMenu(tabId) {
    const { selectedSubMenu } = this.state;
    const newSelectedSubMenu = selectedSubMenu === tabId ? null : tabId;
    this.setState({ selectedSubMenu: newSelectedSubMenu });
  }

  renderDesktopTablist({ listLinks, videoContentList, slugs }) {
    const { didTriggerLeapfrogEvent, selected } = this.state;
    const {
      tabs,
      showId: showCode,
      isPersonality,
      seriesData,
      utagSeriesType,
      favoriteButton,
      socialLinks,
    } = this.props;
    const currentTab = _.find(tabs, { id: selected });
    const seasonTab = isSeasonPanel(currentTab);

    return (
      <Scrollspy
        onUpdate={el => {
          if (el && (isPersonality || seasonTab)) {
            const baseUrl = isPersonality
              ? helperGetPersonalityUrl(showCode)
              : helperGetShowUrl(showCode);
            const newElementId = _.get(el, 'id');
            const newTabId = el.getAttribute('data-tab-id');
            const firstTabId = _.get(tabs, '0.id', null);
            const params = _.get(window.location, 'search').replace(Regex.TRAILING_SLASH, '');
            const firstTab = isPersonality ? newTabId === firstTabId : newElementId === newTabId;
            const nextPath = firstTab
              ? `${baseUrl}${params}`
              : `${baseUrl}${newElementId}/${params}`;
            browserHistory.replace(nextPath);
            this.setState({ selected: newTabId });
            const newTabItem = _.find(tabs, { id: newTabId });
            const { pageTitle, selectedMenuItem } = getTealiumDetailTabData({
              seriesData,
              tab: newTabItem,
            });
            if (!didTriggerLeapfrogEvent && !isPersonality) {
              handleAnalytics({
                event: Events.DETAIL_PAGE_MENU_ITEM_VIEW,
                payload: {
                  pageName: `detail:${utagSeriesType}:${pageTitle}`,
                  pageType: `detail:${utagSeriesType}:menu`,
                  selectedMenuItem,
                },
              });
              this.setState({ didTriggerLeapfrogEvent: true });
            }
          }
        }}
        items={slugs}
        offset={-200}
        ref={el => {
          this.scrollSpyContainer = el;
        }}
      >
        <li className={classNames(Style.favoriteButton, Style.actionButtons)}>{favoriteButton}</li>
        {this.renderVideoContentTabs(videoContentList)}
        {listLinks}
        <li className={Style.actionButtons}>{socialLinks}</li>
      </Scrollspy>
    );
  }

  renderPlaylistLinks(playlistLinks) {
    const { playlist } = this.props;
    return (
      playlist && (
        <li className={Style.playlistContainer}>
          <div className={Style.playlist}>
            <ul>{playlistLinks}</ul>
          </div>
        </li>
      )
    );
  }

  renderVideoContentTabs(videoContentList) {
    if (_.isEmpty(videoContentList)) return null;

    if (videoContentList.length === 1) {
      const { linkTo, name, onClick, isSelected } = videoContentList[0];
      const tabClasses = [Style.tab];
      if (isSelected) tabClasses.push(Style.active);
      const { target, rel } = getUrlTarget(linkTo);
      return (
        <li key={`list-${name}`}>
          <Link
            key={name}
            className={classNames(tabClasses)}
            to={linkTo}
            target={target}
            rel={rel}
            onClick={onClick}
          >
            {name}
          </Link>
        </li>
      );
    }

    const { tabIndex, tabs } = this.props;
    const { videoContentDropdownOpen } = this.state;
    const dropdownLabel = _.some(tabs, 'headline') ? 'global_dropdownLabel' : 'global_seasonsLabel';
    const defaultText = _.get(window.Language, dropdownLabel);
    const toggleDropdown = val => this.setState({ videoContentDropdownOpen: val });
    const selected = _.get(videoContentList, `${tabIndex}.name`);
    const containerClass = selected ? seasonDropdownTheme.isActive : null;
    return (
      <Dropdown
        className={containerClass}
        defaultText={defaultText}
        displayResults={videoContentDropdownOpen}
        expanded={videoContentDropdownOpen}
        getIcon={onClick => <DropdownIcon onClick={onClick} />}
        items={videoContentList}
        onCloseDropdown={() => {
          toggleDropdown(false);
        }}
        onOpenDropdown={() => {
          toggleDropdown(true);
        }}
        preserveTitle={videoContentDropdownOpen}
        selected={selected}
        theme={seasonDropdownTheme}
      />
    );
  }

  render() {
    const {
      breakpoint,
      className,
      isPersonality,
      pageId,
      overlay,
      setOverlay,
      tabIndex,
      tabs,
    } = this.props;
    const { tabListSidebar, disableHardwareAcceleration } = BREAKPOINTS[breakpoint];

    const { listLinks, playlistLinks, videoContentList, slugs, tabList } = this.createTabs({
      tabs,
    });

    let tabListComponent = null;
    if (tabListSidebar) {
      tabListComponent = (
        <Sticky
          topOffset={-80}
          data-testid="sticky"
          style={disableHardwareAcceleration && { transform: 'initial' }}
        >
          {this.renderDesktopTablist({ listLinks, playlistLinks, videoContentList, slugs })}
        </Sticky>
      );
    } else {
      tabListComponent = !_.isEmpty(tabList) && (
        <TabListMobile
          tabs={tabList}
          overlay={overlay}
          setOverlay={setOverlay}
          tabIndex={tabIndex}
          pageId={pageId}
          isPersonality={isPersonality}
        />
      );
    }

    const containerClassNames = classNames([
      Style.tabList,
      className,
      !tabListComponent && Style.noTabs,
    ]);
    return <div className={containerClassNames}>{tabListComponent}</div>;
  }
}

TabList.defaultProps = {
  className: null,
  favoriteButton: null,
  isBrandingClicked: false,
  isPersonality: false,
  noTabHomepage: null,
  overlay: null,
  pageId: null,
  pageType: null,
  pageViewEvent: () => {},
  playlist: null,
  seriesData: {},
  seriesType: null,
  setIsBrandingClicked: () => {},
  socialLinks: null,
  subTabIndex: null,
  tabIndex: false,
  togglePlaylist: () => {},
  utagSeriesType: '',
};

TabList.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  className: PropTypes.string,
  favoriteButton: PropTypes.shape({}),
  isBrandingClicked: PropTypes.bool,
  isPersonality: PropTypes.bool,
  noTabHomepage: PropTypes.string,
  overlay: PropTypes.string,
  pageId: PropTypes.string,
  pageType: PropTypes.string,
  pageViewEvent: PropTypes.func,
  playlist: PropTypes.bool,
  seriesData: PropTypes.shape({}),
  seriesType: PropTypes.string,
  setIsBrandingClicked: PropTypes.func,
  setOverlay: PropTypes.func.isRequired,
  showId: PropTypes.string.isRequired,
  socialLinks: PropTypes.shape({}),
  subTabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  tabs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  togglePlaylist: PropTypes.func,
  utagSeriesType: PropTypes.string,
};

export default TabList;
